/**
 * V2QsAbdLocation 컴포넌트 Props 인터페이스
 * V1 QsAbdLocation의 V2 버전 (순수 UI만)
 *
 * 복부 위치 선택 컴포넌트
 */

/**
 * 복부 위치 키
 */
export type V2QsAbdLocationKey =
  | 'o-abd-epigastric'
  | 'o-abd-luq'
  | 'o-abd-ruq'
  | 'o-abd-lt'
  | 'o-abd-periumbilical'
  | 'o-abd-rt'
  | 'o-abd-llq'
  | 'o-abd-low'
  | 'o-abd-rlq'
  | 'o-abd-whole'
  | 'o-other';

/**
 * 복부 위치 옵션
 */
export interface V2QsAbdLocationOption {
  /**
   * 위치 키
   */
  key: V2QsAbdLocationKey;

  /**
   * 표시할 라벨
   */
  label: string;
}

export interface V2QsAbdLocationProps {
  /**
   * 선택된 위치 키 배열
   */
  value?: string[];

  /**
   * 값 변경 시 콜백
   */
  onChange?: (value: string[]) => void;

  /**
   * 복부 이미지 URL
   */
  abdomenImageUrl?: string;

  /**
   * 전체 복부 옵션 라벨
   */
  wholeAbdomenLabel?: string;

  /**
   * 기타 옵션 라벨
   */
  otherLabel?: string;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 읽기 전용 여부
   */
  readOnly?: boolean;

  /**
   * 에러 상태
   */
  hasError?: boolean;

  /**
   * 에러 메시지
   */
  errorMessage?: string;

  /**
   * 추가 CSS 클래스
   */
  className?: string;
}

export const defaultV2QsAbdLocationProps: Partial<V2QsAbdLocationProps> = {
  disabled: false,
  readOnly: false,
  hasError: false,
  wholeAbdomenLabel: 'Whole abdomen',
  otherLabel: 'Other',
};

/**
 * 기본 복부 위치 목록 (9개 영역)
 */
export const abdLocationKeys: V2QsAbdLocationKey[] = [
  'o-abd-epigastric',
  'o-abd-luq',
  'o-abd-ruq',
  'o-abd-lt',
  'o-abd-periumbilical',
  'o-abd-rt',
  'o-abd-llq',
  'o-abd-low',
  'o-abd-rlq',
];

export const wholeAbdomenKey: V2QsAbdLocationKey = 'o-abd-whole';
export const otherKey: V2QsAbdLocationKey = 'o-other';
